/* PowerSamoray — cart drawer behaves like the menu drawer on mobile.

   Feeds the navbar's height and colour to CSS and toggles html.ps-cart-open.
   (The old injected close button was hidden by CSS, so it is no longer built.) */

(() => {
  const MOBILE_QUERY = '(max-width: 749px)';

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const getComponent = () => document.querySelector('cart-drawer-component');

  function measure() {
    const group = document.getElementById('header-group');
    const bar = group?.querySelector('header') || group?.firstElementChild || group;
    if (!bar) return;

    const rect = bar.getBoundingClientRect();
    const styles = getComputedStyle(bar);

    if (rect.height) {
      document.documentElement.style.setProperty('--ps-header-h', `${Math.round(rect.height)}px`);
    }

    if (styles.backgroundColor && styles.backgroundColor !== 'rgba(0, 0, 0, 0)') {
      document.documentElement.style.setProperty('--ps-nav-bg', styles.backgroundColor);
    }

    document.documentElement.style.setProperty(
      '--ps-nav-bg-image',
      styles.backgroundImage && styles.backgroundImage !== 'none' ? styles.backgroundImage : 'none'
    );
  }

  function onOpen() {
    if (!isMobile()) return;
    measure();
    document.documentElement.classList.add('ps-cart-open');
  }

  function onClose() {
    document.documentElement.classList.remove('ps-cart-open');
  }

  let observer = null;

  function bind() {
    const component = getComponent();
    if (!component) return false;

    if (component.dataset.psCartBound !== 'true') {
      component.dataset.psCartBound = 'true';
      component.addEventListener('dialog:open', onOpen);
      component.addEventListener('dialog:close', onClose);
      measure();
    }

    /* Performance: stop watching the whole document once the drawer is found. */
    observer?.disconnect();
    observer = null;
    return true;
  }

  const start = () => {
    if (bind()) return;

    // The drawer markup is injected by the header section, which can settle late.
    observer = new MutationObserver(() => bind());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Theme editor re-renders the header section: bind again to the new drawer.
  document.addEventListener('shopify:section:load', () => bind());

  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('orientationchange', measure);
})();
